<template>
  <div>
    <BaseTitle :title="$t('content.assigment_create')" :yearPeriode="titleData" />
    <v-row>
      <v-col cols="12" md="6">
        <v-card class="mb-8">
          <div class="pa-8">
            <form-group :name="$t('content.assignment_type')" :validator="$v.form.assignmentTypeId">
              <template slot-scope="{ attrs }">
                <v-select
                  v-if="checkAttendance === true && edit === false"
                  :disabled="edit === true"
                  :items="assignmentType.filter(items => items.value !== 3)"
                  v-bind="attrs"
                  v-model="form.assignmentTypeId"
                >
                  <template #label>
                    {{ $t('content.assignment_type') }}
                    <span class="error--text">*</span>
                  </template>
                </v-select>
                <v-select
                  v-if="checkAttendance === false || edit === true"
                  :items="assignmentType"
                  :disabled="edit === true"
                  v-bind="attrs"
                  v-model="form.assignmentTypeId"
                >
                  <template #label>
                    {{ $t('content.assignment_type') }}
                    <span class="error--text">*</span>
                  </template>
                </v-select>
              </template>
            </form-group>
            <div v-if="form.assignmentTypeId === 3">
              <form-group :name="$t('content.class_title')">
                <template slot-scope="{ attrs }">
                  <v-text-field v-model="dataClass.classroomName" disabled v-bind="attrs" :label="$t('content.class_title')" />
                </template>
              </form-group>
              <form-group :name="$t('content.class_title')">
                <template slot-scope="{ attrs }">
                  <v-text-field :value="courseName" disabled v-bind="attrs" :label="$t('menu.course')" />
                </template>
              </form-group>
            </div>
            <div v-if="form.assignmentTypeId === 2">
              <form-group :name="$t('menu.quiz')" :validator="$v.form.quizId">
                <template slot-scope="{ attrs }">
                  <v-select
                    :items="quizList"
                    item-value="quizId"
                    item-text="quizTitle"
                    :disabled="form.studentSubmitted === true"
                    :label="$t('menu.quiz')"
                    v-bind="attrs"
                    @change="changeQuiz(form.quizId)"
                    v-model="form.quizId"
                  />
                </template>
              </form-group>
            </div>
          </div>
        </v-card>
        <v-card class="mb-8">
          <div class="pa-8">
            <form-group :name="$t('form.status')" :validator="$v.form.lock">
              <template slot-scope="{ attrs }">
                <v-select v-model="form.lock" v-bind="attrs" @change="form.availableDate = null" :label="$t('form.status')" :items="lockItems">
                  <template #label>
                    {{ $t('form.status') }}
                    <span class="error--text">*</span>
                  </template>
                </v-select>
              </template>
            </form-group>
            <div v-if="form.assignmentTypeId !== 3">
              <form-group :name="$t('content.unlock_schedule')">
                <div class="d-flex align-center justify-space-between">
                  <v-switch v-model="form.scheduled" :label="$t('content.file.file_unlock_with_schedule')" />
                </div>
              </form-group>
              <v-row>
                <v-col cols="6" md="6">
                  <form-group :name="$t('form.date')" v-if="form.lock === null" :validator="$v.form.availableDate">
                    <template slot-scope="{ attrs }">
                      <v-menu
                        ref="menuFromStatus"
                        v-model="menuFromStatus"
                        :close-on-content-click="false"
                        :return-value.sync="menuFromStatus"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                      >
                        <template #activator="{ on, attrs:attrActivator }">
                          <v-text-field
                            v-model="form.availableDate"
                            :label="$t('form.date')"
                            readonly
                            v-bind="{ ...attrActivator, ...attrs }"
                            v-on="on"
                            :disabled="!form.scheduled"
                          >
                            <template #append>
                              <svg-icon icon="calendar" class="primary--text mr-3" />
                            </template>
                          </v-text-field>
                        </template>
                        <v-date-picker v-model="form.availableDate" :locale="$i18n.locale">
                          <v-spacer />
                          <v-btn text color="primary" @click="menuFromStatus = false">{{ $t('cancel') }}</v-btn>
                          <v-btn text color="primary" @click="$refs.menuFromStatus.save(form.availableDate)">{{ $t('ok') }}</v-btn>
                        </v-date-picker>
                      </v-menu>
                    </template>
                  </form-group>
                  <form-group :name="$t('form.date')" v-if="form.lock === false" :validator="$v.form.availableDate">
                    <template slot-scope="{ attrs }">
                      <v-menu
                        ref="menuFromStatus"
                        v-model="menuFromStatus"
                        :close-on-content-click="false"
                        :return-value.sync="menuFromStatus"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                      >
                        <template #activator="{ on, attrs:attrActivator }">
                          <v-text-field
                            v-model="form.availableDate"
                            :label="$t('form.date')"
                            readonly
                            v-bind="{ ...attrActivator, ...attrs }"
                            v-on="on"
                            :disabled="!form.scheduled"
                          >
                            <template #append>
                              <svg-icon icon="calendar" class="primary--text mr-3" />
                            </template>
                          </v-text-field>
                        </template>
                        <v-date-picker v-model="form.availableDate" :min="availableFromH" :locale="$i18n.locale">
                          <v-spacer />
                          <v-btn text color="primary" @click="menuFromStatus = false">{{ $t('cancel') }}</v-btn>
                          <v-btn text color="primary" @click="$refs.menuFromStatus.save(form.availableDate)">{{ $t('ok') }}</v-btn>
                        </v-date-picker>
                      </v-menu>
                    </template>
                  </form-group>
                  <form-group :name="$t('form.date')" v-if="form.lock === true" :validator="$v.form.availableDate">
                    <template slot-scope="{ attrs }">
                      <v-menu
                        ref="menuFromStatus"
                        v-model="menuFromStatus"
                        :close-on-content-click="false"
                        :return-value.sync="menuFromStatus"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                      >
                        <template #activator="{ on, attrs:attrActivator }">
                          <v-text-field
                            v-model="form.availableDate"
                            :label="$t('form.date')"
                            readonly
                            v-bind="{ ...attrActivator, ...attrs }"
                            v-on="on"
                            :disabled="!form.scheduled"
                          >
                            <template #append>
                              <svg-icon icon="calendar" class="primary--text mr-3" />
                            </template>
                          </v-text-field>
                        </template>
                        <v-date-picker v-model="form.availableDate" :max="availableFrom" :locale="$i18n.locale">
                          <v-spacer />
                          <v-btn text color="primary" @click="menuFromStatus = false">{{ $t('cancel') }}</v-btn>
                          <v-btn text color="primary" @click="$refs.menuFromStatus.save(form.availableDate)">{{ $t('ok') }}</v-btn>
                        </v-date-picker>
                      </v-menu>
                    </template>
                  </form-group>
                </v-col>
                <v-col cols="6" md="4">
                  <form-group :name="$t('form.time')" v-if="manualSchedule === false" :validator="$v.form.deadlineTimeStatus" no-gutter>
                    <template slot-scope="{ attrs }">
                      <v-menu
                        ref="pickerTimeStatus"
                        v-model="pickerTimeStatus"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        :return-value.sync="pickerTimeStatus"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on, attrs: attrActivator }">
                          <v-text-field
                            v-model="form.deadlineTimeStatus"
                            :label="$t('form.time')"
                            readonly
                            v-bind="{ ...attrActivator, ...attrs }"
                            v-on="on"
                            :disabled="!form.scheduled"
                          >
                            <template #append>
                              <svg-icon icon="clock" class="primary--text mr-3" />
                            </template>
                          </v-text-field>
                        </template>
                        <v-time-picker
                          v-model="form.deadlineTimeStatus"
                          :locale="$i18n.locale"
                          format="24hr"
                          @click:minute="$refs.pickerTimeStatus.save(form.deadlineTimeStatus)"
                        />
                      </v-menu>
                    </template>
                  </form-group>
                  <v-text-field
                    type="time"
                    v-if="form.assignmentTypeId !== 3 && manualSchedule === true"
                    v-model="form.deadlineTimeStatus"
                    :label="$t('form.time')"
                  />
                </v-col>
                <v-col cols="6" md="2">
                  <form-group>
                    <div class="d-flex align-center justify-space-between">
                      <v-switch v-model="manualSchedule" :disabled="!form.scheduled" />
                    </div>
                  </form-group>
                </v-col>
              </v-row>
            </div>
          </div>
        </v-card>
      </v-col>

      <v-col cols="12" md="6">
        <form @submit.prevent="submit">
          <v-card class="mb-8">
            <div class="pa-8">
              <form-group :name="$t('content.assignment_title1')" :validator="$v.form.assignmentTitle">
                <template slot-scope="{ attrs }">
                  <v-text-field
                    v-model="form.assignmentTitle"
                    v-bind="attrs"
                    @input="$v.form.assignmentTitle.$touch()"
                    @blur="$v.form.assignmentTitle.$touch()"
                  >
                    <template #label>
                      {{ $t('content.assignment_title1') }}
                      <span class="error--text">*</span>
                    </template>
                  </v-text-field>
                </template>
              </form-group>

              <v-row v-if="form.assignmentTypeId !== 3">
                <v-col cols="6" md="6">
                  <form-group :name="$t('content.available_from')" v-if="form.assignmentTypeId !== 3" :validator="$v.form.availableFrom">
                    <template slot-scope="{ attrs }">
                      <v-menu
                        ref="menuAvailable"
                        v-model="menuAvailable"
                        :close-on-content-click="false"
                        :return-value.sync="menuAvailable"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                      >
                        <template #activator="{ on, attrs:attrActivator }">
                          <v-text-field v-model="form.availableFrom" readonly v-bind="{ ...attrActivator, ...attrs }" v-on="on">
                            <template #label>
                              {{ $t('content.available_from') }}
                              <span class="error--text">*</span>
                            </template>
                            <template #append>
                              <svg-icon icon="calendar" class="primary--text mr-3" />
                            </template>
                          </v-text-field>
                        </template>
                        <v-date-picker v-model="form.availableFrom" :max="dueDate" :locale="$i18n.locale">
                          <v-spacer />
                          <v-btn text color="primary" @click="menuAvailable = false">{{ $t('cancel') }}</v-btn>
                          <v-btn text color="primary" @click="$refs.menuAvailable.save(form.availableFrom)">{{ $t('ok') }}</v-btn>
                        </v-date-picker>
                      </v-menu>
                    </template>
                  </form-group>
                </v-col>
                <v-col cols="6" md="6">
                  <form-group
                    :name="$t('content.available_time')"
                    v-if="form.assignmentTypeId !== 3 && manualTime === false"
                    no-gutter
                    :validator="$v.form.availableTime"
                  >
                    <template slot-scope="{ attrs }">
                      <v-menu
                        ref="pickerFrom"
                        v-model="pickerFrom"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        :return-value.sync="pickerFrom"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on, attrs: attrActivator }">
                          <v-text-field v-model="form.availableTime" :disabled="!editable" readonly v-bind="{ ...attrActivator, ...attrs }" v-on="on">
                            <template #label>
                              {{ $t('content.available_time') }}
                              <span class="error--text">*</span>
                            </template>
                            <template #append>
                              <svg-icon icon="clock" class="primary--text mr-3" />
                            </template>
                          </v-text-field>
                        </template>
                        <v-time-picker
                          v-model="form.availableTime"
                          format="24hr"
                          :locale="$i18n.locale"
                          @click:minute="$refs.pickerFrom.save(form.availableTime)"
                        />
                      </v-menu>
                    </template>
                  </form-group>
                  <v-text-field
                    type="time"
                    v-if="form.assignmentTypeId !== 3 && manualTime === true"
                    v-model="form.availableTime"
                    :label="$t('content.available_time')"
                  />
                </v-col>
                <!-- <v-col cols="6" md="2" v-if="form.assignmentTypeId !== 3">
                  <form-group :name="$t('content.autolock')">
                    <div class="d-flex align-center justify-space-between">
                      <v-switch v-model="manualTime" />
                    </div>
                  </form-group>
                </v-col> -->
              </v-row>
              <v-row v-if="form.assignmentTypeId !== 3">
                <!-- from -->
                <v-col cols="6" md="6" v-if="form.assignmentTypeId !== 3">
                  <form-group :name="$t('content.due_date')" v-if="form.assignmentTypeId !== 3" :validator="$v.form.dueDate">
                    <template slot-scope="{ attrs }">
                      <v-menu
                        ref="menuFrom"
                        v-model="menuFrom"
                        :close-on-content-click="false"
                        :return-value.sync="menuFrom"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                      >
                        <template #activator="{ on, attrs:attrActivator }">
                          <v-text-field v-model="form.dueDate" readonly v-bind="{ ...attrActivator, ...attrs }" v-on="on">
                            <template #label>
                              {{ $t('content.due_date') }}
                              <span class="error--text">*</span>
                            </template>
                            <template #append>
                              <svg-icon icon="calendar" class="primary--text mr-3" />
                            </template>
                          </v-text-field>
                        </template>
                        <v-date-picker v-model="form.dueDate" :min="form.availableFrom" :locale="$i18n.locale">
                          <v-spacer />
                          <v-btn text color="primary" @click="menuFrom = false">{{ $t('cancel') }}</v-btn>
                          <v-btn text color="primary" @click="$refs.menuFrom.save(form.dueDate)">{{ $t('ok') }}</v-btn>
                        </v-date-picker>
                      </v-menu>
                    </template>
                  </form-group>
                </v-col>
                <v-col cols="6" md="6" v-if="form.assignmentTypeId !== 3">
                  <form-group
                    :name="$t('content.due_time')"
                    v-if="form.assignmentTypeId !== 3 && manualDue === false"
                    :validator="$v.form.deadlineTime"
                    no-gutter
                  >
                    <template slot-scope="{ attrs }">
                      <v-menu
                        ref="pickerTime"
                        v-model="pickerTime"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        :return-value.sync="pickerTime"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on, attrs: attrActivator }">
                          <v-text-field v-model="form.deadlineTime" :disabled="!editable" readonly v-bind="{ ...attrActivator, ...attrs }" v-on="on">
                            <template #label>
                              {{ $t('content.due_time') }}
                              <span class="error--text">*</span>
                            </template>
                            <template #append>
                              <svg-icon icon="clock" class="primary--text mr-3" />
                            </template>
                          </v-text-field>
                        </template>
                        <v-time-picker
                          v-model="form.deadlineTime"
                          format="24hr"
                          :locale="$i18n.locale"
                          @click:minute="$refs.pickerTime.save(form.deadlineTime)"
                        />
                      </v-menu>
                    </template>
                  </form-group>
                  <v-text-field
                    type="time"
                    v-if="form.assignmentTypeId !== 3 && manualDue === true"
                    v-model="form.deadlineTime"
                    :label="$t('content.due_time')"
                  />
                </v-col>
                <!-- <v-col cols="6" md="2" v-if="form.assignmentTypeId !== 3">
                  <form-group :name="$t('content.autolock')">
                    <div class="d-flex align-center justify-space-between">
                      <v-switch v-model="manualDue" />
                    </div>
                  </form-group>
                </v-col> -->
              </v-row>
              <form-group :name="$t('content.group')" :validator="$v.form.assignmentGroupId">
                <template slot-scope="{ attrs }">
                  <v-select
                    v-model="form.assignmentGroupId"
                    v-bind="attrs"
                    item-value="assignmentGroupId"
                    item-text="assignmentGroupName"
                    :items="group"
                    :disabled="!editable || !group"
                    @input="$v.form.assignmentGroupId.$touch()"
                    @blur="$v.form.assignmentGroupId.$touch()"
                  >
                    <template #label>
                      {{ $t('content.group') }}
                      <span class="error--text">*</span>
                    </template>
                  </v-select>
                </template>
              </form-group>
              <form-group :name="$t('content.total_score')" :validator="$v.form.totalPoint">
                <template slot-scope="{ attrs }">
                  <v-text-field
                    type="number"
                    @keydown="nameKeydown($event)"
                    v-model.number="form.totalPoint"
                    v-bind="attrs"
                    v-number
                    :disabled="disableTotal === true"
                    :min="0"
                    :label="$t('content.total_score')"
                    @input="$v.form.totalPoint.$touch()"
                    @blur="$v.form.totalPoint.$touch()"
                  >
                    <template #label>
                      {{ $t('content.total_score') }}
                      <span class="error--text">*</span>
                    </template>
                  </v-text-field>
                </template>
              </form-group>
              <form-group :name="$t('content.minimum_score')">
                <template slot-scope="{ attrs }">
                  <v-text-field
                    type="number"
                    @keydown="nameKeydown($event)"
                    @input="maximum($event)"
                    v-model.number="form.minimumPoint"
                    v-bind="attrs"
                    v-number
                    :max="form.totalPoint"
                    :min="0"
                    :label="$t('content.minimum_score')"
                    :disabled="!editable"
                  />
                </template>
              </form-group>
              <div v-if="form.assignmentTypeId === 1 || form.assignmentTypeId === 2">
                <form-group :name="$t('content.attempt')" :validator="$v.form.attempt">
                  <template slot-scope="{ attrs }">
                    <v-select :items="attemptValue" v-bind="attrs" :disabled="form.autoLock === true" v-model="form.attempt">
                      <template #label>
                        {{ $t('content.attempt') }}
                        <span class="error--text">*</span>
                      </template>
                    </v-select>
                  </template>
                </form-group>
                <form-group :name="$t('content.other_value')" v-if="form.attempt === 0" :validator="$v.tempoAttempt">
                  <template slot-scope="{ attrs }">
                    <v-text-field
                      type="number"
                      v-model="tempoAttempt"
                      v-bind="attrs"
                      v-number
                      :label="$t('content.other_value')"
                      @input="$v.tempoAttempt.$touch()"
                      @blur="$v.tempoAttempt.$touch()"
                    />
                  </template>
                </form-group>
                <form-group :name="$t('content.autolock')">
                  <div class="d-flex align-center justify-space-between">
                    <v-switch v-model="form.autoLock" :label="$t('content.autolock')" />
                  </div>
                </form-group>
              </div>
              <form-group :name="$t('form.file')" :validator="$v.form.file" no-gutter>
                <template slot-scope="{ attrs }">
                  <v-file-input
                    :label="$t('form.file')"
                    accept=".jpg,.jpeg,.png,.pdf,.mp4,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.mp3,.sb3"
                    chips
                    show-size
                    v-bind="attrs"
                    small-chips
                    v-model="form.file"
                    truncate-length="15"
                    @input="$v.form.file.$touch()"
                    @blur="$v.form.file.$touch()"
                  ></v-file-input>
                </template>
              </form-group>
              <form-group :name="$t('form.desc')">
                <template slot-scope="{ attrs }">
                  <div class="app-section-title mb-2">{{ $t('form.desc') }}</div>
                  <text-editor v-bind="attrs" v-model="form.description" />
                </template>
              </form-group>

              <div v-if="fileList.fileUrl">
                <!-- File Viewer -->
                <file-viewer :data="preview" v-model="dialogPreview" @onHide="hidePreview" />

                <a href="javascript:(0)" @click.prevent="previewFileTeacher(undefined, { fileList })"
                  >{{ fileList.fileName }}.{{ fileList.extension }}</a
                >
              </div>
            </div>
          </v-card>
          <div class="d-flex justify-end align-center">
            <v-btn color="primary" class="btn-primary-custom mr-3" outlined @click="back">{{ $t('cancel') }}</v-btn>
            <v-btn color="primary" class="btn-primary-custom" @click="submit" :loading="loading">
              {{ $t('submit') }}
            </v-btn>
          </div>
        </form>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { required, maxValue } from 'vuelidate/lib/validators';
import { fileSize, fileType } from '@/validators';
import BaseTitle from '@/components/base/Title';
import FileViewer from '@/components/FileViewer';
import TextEditor from '@/components/base/TextEditor.vue';

const extAllowed = ['mp4', 'mp3', 'pptx', 'ppt', 'doc', 'docx', 'xls', 'xlsx', 'pdf', 'jpg', 'png', 'jpeg', 'sb3'];

export default {
  name: 'AssignmentCreate',
  props: {
    editable: {
      type: Boolean,
      default: true
    }
  },
  components: {
    BaseTitle,
    FileViewer,
    TextEditor
  },
  computed: {
    ...mapGetters({
      user: 'Auth/user',
      tokenBearer: 'Auth/token',
      nameCourse: 'CourseList/nameCourse'
    }),
    dueDate() {
      if (this.form.dueDate) {
        var hari = new Date(this.form.dueDate) - 86400000;

        var d = new Date(hari),
          month = '' + (d.getMonth() + 1),
          day = '' + d.getDate(),
          year = d.getFullYear();

        if (month.length < 2) month = '0' + month;
        if (day.length < 2) day = '0' + day;

        return [year, month, day].join('-');
      } else {
        return null;
      }
    },
    availableFrom() {
      if (this.form.availableFrom) {
        var hari = new Date(this.form.availableFrom) - 86400000;

        var d = new Date(hari),
          month = '' + (d.getMonth() + 1),
          day = '' + d.getDate(),
          year = d.getFullYear();

        if (month.length < 2) month = '0' + month;
        if (day.length < 2) day = '0' + day;

        return [year, month, day].join('-');
      } else {
        return null;
      }
    },
    availableFromH() {
      if (this.form.availableFrom) {
        var hari = new Date(this.form.availableFrom);
        var ss = new Date(hari.getTime() + 86400000);

        var d = new Date(ss),
          month = '' + (d.getMonth() + 1),
          day = '' + d.getDate(),
          year = d.getFullYear();

        if (month.length < 2) month = '0' + month;
        if (day.length < 2) day = '0' + day;

        return [year, month, day].join('-');
      } else {
        return null;
      }
    },
    courseName() {
      return `${localStorage.getItem('courseName') ?? ''}`;
    },
    lockItems() {
      return [
        { text: this.$t('unlock'), value: false },
        { text: this.$t('lock'), value: true }
      ];
    },
    assignmentType() {
      return [
        // { value: 4, text: this.$t('content.assignment_item.manual_input') },
        // { value: 3, text: this.$t('content.assignment_item.attendance') },
        // { value: 2, text: this.$t('content.assignment_item.quiz') },
        { value: 1, text: this.$t('content.assignment_item.upload_files') }
      ];
    },
    attemptValue() {
      return [
        { value: 1, text: 1 },
        { value: 2, text: 2 },
        { value: 3, text: 3 },
        { value: 4, text: 4 },
        { value: 5, text: 5 },
        { value: 0, text: this.$t('content.other_value') },
        { value: 'unlimited', text: this.$t('content.unlimited') }
      ];
    }
  },
  validations() {
    return {
      tempoAttempt: this.form.attempt === 0 ? { required, maxValue2: maxValue(20) } : {},
      form: {
        // description: { required },
        // minimumPoint: { required },
        totalPoint: { required },
        assignmentGroupId: { required },
        // dueDate: this.form.assignmentTypeId !== 3 ? { required } : {},
        // deadlineTime: this.form.assignmentTypeId !== 3 ? { required } : {},
        attempt:
          (this.form.assignmentTypeId === 1 && this.form.autoLock === false) || (this.form.assignmentTypeId === 2 && this.form.autoLock === false)
            ? { required }
            : {},
        assignmentTitle: { required },
        lock: { required },
        deadlineTime: { required },
        dueDate: { required },
        availableFrom: { required },
        availableTime: { required },
        file: {
          fileSize: fileSize(2000),
          fileType: fileType(extAllowed)
        },
        // autoLock: this.form.assignmentTypeId === 1 || this.form.assignmentTypeId === 2 ? { required } : {},
        availableDate: this.form.scheduled === true ? { required } : {},
        deadlineTimeStatus: this.form.scheduled === true ? { required } : {},
        assignmentTypeId: { required }
      }
    };
  },
  data: () => ({
    manualDue: false,
    manualTime: false,
    manualSchedule: false,
    edit: false,
    loading: false,
    menuFrom: false,
    menuFromStatus: false,
    pickerTimeStatus: false,
    pickerTime: false,
    pickerFrom: false,
    menuAvailable: false,
    dataClass: '',
    temporaryDateDue: '',
    temporaryDate: '',
    temporaryFrom: '',
    group: [],
    quizList: [],
    form: {
      assignmentTypeId: null,
      attempt: '',
      description: '',
      minimumPoint: 0,
      totalPoint: null,
      assignmentGroupId: null,
      dueDate: '',
      deadlineTime: '',
      assignmentTitle: null,
      lock: null,
      quizId: null,
      scheduled: '',
      availableFrom: '',
      availableTime: null,
      availableDate: null,
      deadlineTimeStatus: null,
      fileName: null,
      file: null,
      studentSubmitted: '',
      autoLock: false
    },
    fileList: {},
    dialogPreview: false,
    preview: {},
    tempoAttempt: '',
    checkAttendance: '',
    disableTotal: false,
    titleData: ''
  }),
  methods: {
    changeAttempt() {
      this.form.attempt = 1;
    },
    changeQuiz(e) {
      var data = this.quizList.find(form => form.quizId === e);
      this.form.totalPoint = data.totalScore;
      this.disableTotal = true;
    },
    maximum(e) {
      if (Number(e) > Number(this.form.totalPoint)) {
        this.$nextTick(() => {
          this.form.minimumPoint = this.form.totalPoint;
        });
      }
    },
    nameKeydown(e) {
      if (/^\W$/.test(e.key)) {
        e.preventDefault();
      }
    },
    // File Viewer Teacher
    previewFileTeacher(e, { fileList }) {
      this.dialogPreview = true;
      this.$set(this, 'preview', fileList);
    },
    hidePreview() {
      this.dialogPreview = null;
      this.$set(this, 'preview', {});
    },
    attendanceCheck() {
      const { classId, courseId } = this.$route.params;
      this.$store
        .dispatch('Assignment/checkAttendance', {
          classId,
          courseId,
          classSectionId: this.$route.params.classSectionId ? this.$route.params.classSectionId : ''
        })
        .then(res => (this.checkAttendance = res.attendance))
        .catch(e => this.$store.dispatch('general/showErrorReqNotification', e));
    },
    getDataEdit() {
      this.$store.dispatch('Assignment/fetchDetail', this.$route.params.assignmentId).then(res => {
        Object.keys(this.form).forEach(form => {
          this.form[form] = res[form];
        });

        if (!res.attempt) {
          this.form.attempt = 'unlimited';
        }
        this.fileList = res;

        if (res.attempt > 5) {
          this.tempoAttempt = res.attempt;
          this.form.attempt = 0;
        }

        if (res.assignmentTypeId === 2) {
          const { assignmentId } = this.$route.params;
          this.$store
            .dispatch('Assignment/fetchListQuizEdit', { assignmentId })
            .then(res => (this.quizList = res))
            .catch(e => this.$store.dispatch('general/showErrorReqNotification', e));
        }
      });
    },
    getGroup() {
      const { classId, courseId } = this.$route.params;
      this.$store
        .dispatch('Assignment/fetchList', {
          classId,
          courseId,
          classSectionId: this.$route.params.classSectionId ? this.$route.params.classSectionId : ''
        })
        .then(res => (this.group = res))
        .catch(e => this.$store.dispatch('general/showErrorReqNotification', e));
    },
    getQuiz() {
      if (!this.$route.params.assignmentId) {
        const { classId, courseId } = this.$route.params;
        this.$store
          .dispatch('Assignment/fetchListQuiz', {
            classId,
            courseId,
            classSectionId: this.$route.params.classSectionId ? this.$route.params.classSectionId : ''
          })
          .then(res => (this.quizList = res))
          .catch(e => this.$store.dispatch('general/showErrorReqNotification', e));
      }
    },
    getDataClass() {
      if (!this.$route.params.classSectionId) {
        this.$store
          .dispatch('Class/fetchClassroomCourseName', { classId: this.$route.params.classId, courseId: this.$route.params.courseId })
          .then(res => {
            if (this.user.cerdasTypeId === 2 || this.user.cerdasTypeId === null) {
              this.$store.dispatch('SchoolClass/fetchDetail', this.$route.params.classId).then(resa => {
                this.dataClass = resa;
                this.titleData = res + ` ( ${resa.yearPeriode} ) `;
              });
            } else {
              this.$store.dispatch('Class/fetchListLiteDetail', this.$route.params.classId).then(resa => {
                this.dataClass = resa;
                this.titleData = res + ` ( ${resa.yearPeriode} ) `;
              });
            }
          });
      } else {
        this.$store.dispatch('ClassSection/getListDetail', { classSectionId: this.$route.params.classSectionId }).then(res => {
          if (this.user.cerdasTypeId === 2 || this.user.cerdasTypeId === null) {
            this.$store.dispatch('SchoolClass/fetchDetail', this.$route.params.classId).then(resa => {
              this.dataClass = resa;
              this.titleData = res.classroomName + ` ${res.numberClass}` + ` ( ${resa.yearPeriode} ) `;
            });
          }
        });
      }
    },
    submit() {
      this.$v.$touch();
      if (this.$v.$invalid) return;

      this.loading = true;
      const payload = { ...this.form };

      if (payload.availableFrom) {
        this.temporaryFrom = payload.availableFrom;
        payload.availableFrom = payload.availableFrom.concat(' ', payload.availableTime);
      }

      if (payload.dueDate) {
        this.temporaryDateDue = payload.dueDate;
        payload.dueDate = payload.dueDate.concat(' ', payload.deadlineTime);
      }
      if (payload.availableDate) {
        this.temporaryDate = payload.availableDate;
        payload.availableDate = payload.availableDate.concat(' ', payload.deadlineTimeStatus);
      }

      if (payload.attempt === 0) {
        payload.attempt = this.tempoAttempt;
      }
      if (payload.file) {
        let fpath = payload.file.name;
        fpath = fpath.replace(/\\/g, '/');

        let fname = fpath.substring(fpath.lastIndexOf('/') + 1, fpath.lastIndexOf('.'));

        if (/^[a-zA-Z0-9|.| |_|-]*$/i.test(fname)) {
          this.form.fileName = fname;
          payload.fileName = fname;
        } else {
          this.$store.dispatch('general/showErrorNotification', { message: this.$t('content.word_upload') });
          this.loading = false;
          return;
        }
      }
      const { classId, courseId, assignmentId } = this.$route.params;

      this.$store
        .dispatch(`Assignment/${this.edit ? 'update' : 'save'}`, {
          assignmentId,
          classId,
          courseId,
          classSectionId: this.$route.params.classSectionId ? this.$route.params.classSectionId : '',
          ...payload
        })
        .then(() => {
          const { classSectionId } = this.$route.params;
          const isEdit = this.edit;

          let routeName = '';

          if (classSectionId) {
            routeName = isEdit ? 'TeacherAssignmentSectionUpdateSuccess' : 'TeacherAssignmentSectionSuccess';
          } else {
            routeName = isEdit ? 'TeacherAssignmentUpdateSuccess' : 'TeacherAssignmentSuccess';
          }

          this.$router.push({ name: routeName });
        })
        .catch(e => this.$store.dispatch('general/showErrorReqNotification', e))
        .finally(() => (this.loading = false));
      if (this.form.availableDate) {
        this.form.availableDate = this.temporaryDate;
      }
      if (this.form.dueDate) {
        this.form.dueDate = this.temporaryDateDue;
      }
      if (this.form.availableFrom) {
        this.form.availableFrom = this.temporaryFrom;
      }
    },
    back() {
      if (!this.$route.params.classSectionId) {
        this.$router.push({ name: 'TeacherAssignment' });
      } else {
        this.$router.push({ name: 'TeacherAssignmentSection' });
      }
    },
    preventNav(event) {
      if (!this.edit || !this.$v.$anyDirty) return;
      event.preventDefault();
      event.returnValue = '';
    }
  },
  created() {
    this.getQuiz();
    this.getDataClass();
    this.getGroup();
    this.attendanceCheck();
    // console.info(![null, true].includes(this.form.lock));
    if (this.$route.params.assignmentId) {
      this.edit = true;
      this.getDataEdit();
      this.disableTotal = true;
    }
  }
};
</script>
